"use strict";
/*
 * Created on 10 01 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../DomainObject");
/**
 * Overview settings with filter, sorting, projection and pagination.
 *
 * Note: You can add possible grouping or other capabilities.
 *
 * @author Radek Beran
 */


var Overview =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(Overview, _DomainObject_1$Domai);

  function Overview(filter, sorting, projection, pagination) {
    var _this;

    _classCallCheck(this, Overview);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Overview).call(this));
    _this.filter = filter;
    _this.sorting = sorting;
    _this.projection = projection;
    _this.pagination = pagination;
    return _this;
  }

  _createClass(Overview, [{
    key: "withFilter",
    value: function withFilter(filter) {
      return this.copy('filter', filter);
    }
  }, {
    key: "mapFilter",
    value: function mapFilter(f) {
      return new Overview(f(this.filter), this.sorting, this.projection, this.pagination);
    }
  }, {
    key: "withPagination",
    value: function withPagination(pagination) {
      return this.copy('pagination', pagination);
    }
  }, {
    key: "withSorting",
    value: function withSorting(sorting) {
      return this.copy('sorting', sorting);
    }
  }, {
    key: "withProjection",
    value: function withProjection(projection) {
      return this.copy('projection', projection);
    }
  }]);

  return Overview;
}(DomainObject_1.DomainObject);

exports.Overview = Overview;